import { gql } from '@apollo/client';

const fetchAvailableCountriesQuery = gql`
  query fetchAvailableCountries {
    availableCountries {
      totalCount
      nodes {
        isoCode
        name
      }
    }
  }
`;

export default fetchAvailableCountriesQuery;
